import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recursive_selector_element = _resolveComponent("recursive-selector-element")!

  return (_openBlock(), _createElementBlock("div", {
    ref: (el) => { _ctx.viewport_inner = el },
    tabindex: "0",
    onKeydown: [
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowDown(1)), ["exact","prevent"]), ["down"])),
      _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.trackArrowUp(1)), ["exact","prevent"]), ["up"])),
      _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleCurrent && _ctx.toggleCurrent(...args)), ["prevent"]), ["enter"]))
    ],
    class: "no-outline"
  }, [
    (_ctx.returnType === 'none' || !_ctx.elements)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel, (element, index) => {
            return (_openBlock(), _createBlock(_component_recursive_selector_element, {
              ref_for: true,
              ref: (el) => { _ctx.divs[index] = el },
              key: index,
              "element-chain": _ctx.takeIdsOnly ? (_ctx.elementType === 1 ? [element.Id] : (_ctx.elementType === 9 ? [element[_ctx.entityInsideName].Id] : [element])) : [element],
              "parent-idx": index,
              "is-root": true,
              "return-type": _ctx.returnType,
              "nested-key-name": _ctx.nestedKeyName,
              "element-type": _ctx.elementType,
              "take-ids-only": _ctx.takeIdsOnly,
              "entity-inside-name": _ctx.entityInsideName,
              "allow-multiple": _ctx.allowMultiple,
              "hide-checkboxes": _ctx.hideCheckboxes,
              "show-records": _ctx.showRecords,
              "is-column": _ctx.isColumn,
              "open-on-start": _ctx.openOnStart,
              "filter-out-list": _ctx.filterOutList,
              "parameter-type-name": _ctx.parameterTypeName,
              "value-type": element.ValueType,
              "search-regex": _ctx.searchRegex,
              "filter-string": _ctx.filterString,
              class: _normalizeClass(['q-py-none', { 'rec-lst-subselection': _ctx.index_selected === index }]),
              onElementToggled: ($event: any) => (_ctx.elementToggled(index)),
              modelValue: _ctx.theModel[index],
              "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event)
            }, null, 8, ["element-chain", "parent-idx", "return-type", "nested-key-name", "element-type", "take-ids-only", "entity-inside-name", "allow-multiple", "hide-checkboxes", "show-records", "is-column", "open-on-start", "filter-out-list", "parameter-type-name", "value-type", "search-regex", "filter-string", "class", "onElementToggled", "modelValue", "onUpdate:modelValue"]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elements, (element, index) => {
            return (_openBlock(), _createBlock(_component_recursive_selector_element, {
              ref_for: true,
              ref: (el) => { _ctx.divs[index] = el },
              key: index,
              element: element,
              "element-chain": _ctx.takeIdsOnly ? (_ctx.elementType === 1 ? [element.Id] : (_ctx.elementType === 9 ? [element[_ctx.entityInsideName].Id] : [element])) : [element],
              "parent-idx": index,
              "is-root": true,
              "return-type": _ctx.returnType,
              "nested-key-name": _ctx.nestedKeyName,
              "element-type": _ctx.elementType,
              "take-ids-only": _ctx.takeIdsOnly,
              "entity-inside-name": _ctx.entityInsideName,
              "allow-multiple": _ctx.allowMultiple,
              "hide-checkboxes": _ctx.hideCheckboxes,
              "show-records": _ctx.showRecords,
              "is-column": _ctx.isColumn,
              "open-on-start": _ctx.openOnStart,
              "filter-out-list": _ctx.filterOutList,
              "parameter-type-name": _ctx.parameterTypeName,
              "value-type": element.ValueType,
              "search-regex": _ctx.searchRegex,
              "filter-string": _ctx.filterString,
              class: _normalizeClass(['q-py-none', { 'rec-lst-subselection': _ctx.index_selected === index }]),
              onElementToggled: ($event: any) => (_ctx.elementToggled(index)),
              modelValue: _ctx.theModel,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event))
            }, null, 8, ["element", "element-chain", "parent-idx", "return-type", "nested-key-name", "element-type", "take-ids-only", "entity-inside-name", "allow-multiple", "hide-checkboxes", "show-records", "is-column", "open-on-start", "filter-out-list", "parameter-type-name", "value-type", "search-regex", "filter-string", "class", "onElementToggled", "modelValue"]))
          }), 128))
        ]))
  ], 544))
}